import { createContext, useContext } from 'react';

/**
 * Whether the enclosing `Sidebar` is rendered in its collapsed
 * (icon-only) form. Default `false` so headerless tests can render
 * `RailHead` / `BrowseSidebarUserFooter` without wrapping in a Sidebar.
 */
export const SidebarCollapsedContext = createContext<boolean>(false);

export function useSidebarCollapsed(): boolean {
  return useContext(SidebarCollapsedContext);
}
